import * as React from 'react'
import styled from 'styled-components'
import { Section, SectionContent, SectionCta } from '../../Section'
import SelectChain from '../helpers/SelectChain'
import { MqDesktop, MqTablet } from 'streamr-ui/css/consts'

export function AddToWallet() {
    return (
        <AddToWalletRoot>
            <SectionContent>
                <SectionCta $block>
                    <h4>Add DATA to your&nbsp;wallet</h4>
                    <TokenControlsWrap>
                        <SelectChain />
                    </TokenControlsWrap>
                </SectionCta>
            </SectionContent>
        </AddToWalletRoot>
    )
}

const TokenControlsWrap = styled.div`
    background: #fafafa;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;

    @media ${MqDesktop} {
        margin-top: 28px;
        padding: 32px;
    }
`

const AddToWalletRoot = styled(Section)`
    --SectionCta_Width: 824px;
    --SectionCta_Padding: 40px 56px;

    padding-top: 0 !important;

    h4 {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #0c009a;
        margin: 0;
    }

    @media ${MqTablet} {
        --SectionCta_Padding: 56px 80px;
    }
`
